var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","color":"info","title":"Editar experiência"},on:{"click":function($event){return _vm.editarExp()}}},[_c('v-icon',[_vm._v("mdi-pencil-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }